import React from 'react';

function Myanmar(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124057)">
        <mask
          id="mask0_800_124057"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124057)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 16H36V24H0V16Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 8H36V16H0V8Z"
            fill="#5EAA22"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V8H0V0Z"
            fill="#FFD018"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0699 15.9755L12.2751 19.2504L14.2188 13.5174L10.0856 9.77172L15.784 9.66107L18.305 4.00124L20.6023 9.73583L26.2871 9.82403L22.0151 13.6383L24.01 19.0923L18.0699 15.9755Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124057">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Myanmar;
